// reducers/CategoryReducer.js
const initialState = {
  locations: [],
};

const LocationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOCATIONS":
      return {
        ...state,
        locations: action.payload,
      };
    default:
      return state;
  }
};

export default LocationsReducer;
